import {ServiceBase} from "../ServiceBase";
import {IBrowserButtonsHandlerService} from "./broswer-buttons-handler.service.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";

export class BrowserButtonsHandlerService extends ServiceBase implements IBrowserButtonsHandlerService {

    private pushedFakeHistoryState: boolean = false;

    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);
        this._subscribe();
    }

    private _subscribe() {
        // this._handleSideMenusCloseOnBackButtonClick();
    }

    private _handleSideMenusCloseOnBackButtonClick() {

        this.reaction(() => ({
                isMobileSideMenuOpen: this.services.sideMenu.isMobileMenuOpen,
                isUserAreaMenuOpen: this.services.userMenu.isOpen,
            }),
            ({isMobileSideMenuOpen, isUserAreaMenuOpen}) => {
                if(!this.pushedFakeHistoryState && (isMobileSideMenuOpen || isUserAreaMenuOpen)){
                    this.services.location.pushWithoutValidation(this.services.window.pathname);
                    this.pushedFakeHistoryState = true;
                }else if(this.pushedFakeHistoryState && !isMobileSideMenuOpen && !isUserAreaMenuOpen){
                    this.services.location.goBack();
                }
            });

        this._onBackButtonClicked(() => {
            this.services.sideMenu.closeMobileMenu();
            this.services.userMenu.closeMenu();
        });
    }

    private _onBackButtonClicked(callback){
        const _callback = (e) => {
            this.pushedFakeHistoryState = false;
            callback(e);
        }

        if(this.services.device.hybrid.isHybrid){
            return this.services.window.subscribeTo.hardwareBackButton(_callback);
        }

        return this.services.window.subscribeTo.popstate(_callback);
    }
}